<template>
	<section class="course-content pt-3 pb-2">
		<div class="container">
			<div class="inner-sec-w3ls py-lg-5 py-3">
				<div class="row">
					<div class="col-lg-12 content-right mt-3">
						<h3 class="heading mb-4">贯穿K12的课程</h3>
						<p class="">码速编程网涵盖了机器人编程、Python语言编程、人工智能基础开发、信息学奥赛编程等课程，适合孩子7-16岁少年儿童的在小学、初中、高中全段学习（K12）。</p>
						<div class="mt-4 mb-5" v-for="item of courseContentList" :key="item.id">
							<ul class="class-tabs class-tabs-w clearfix">
								<li class="on">
									<div class="link-tab">
										<p><b>{{item.name}}</b></p>
										<p><span>{{item.desc}}</span></p>
									</div>
								</li>
							</ul>
							<div class="class-content mt-4">
								<div class="row">
									<div class="col-sm-12 col-md-5">
										<img :src="item.img">
									</div>
									<div class="col-sm-12 col-md-7">
										<div class="info-cont">
											<p class="img-group">
												<span v-for="imgGroup of item.imgGroup"><img :src="imgGroup" alt="" height="28"></span>
											</p>
											<p class="tit">{{item.title}}</p>
											<p class="cont">{{item.content}}</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	export default {
		name: 'CourseContent',
		props: ["courseContentList"]
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/css/course/components/CourseContent.scss';
</style>